export default class CalculationStateData {
    constructor(voyageId, computation, stateId, stateValue, stateTitle, progress) {
        this.voyageId = voyageId;
        this.computation = computation;
        this.stateId = stateId;
        this.stateValue = stateValue;
        this.stateTitle = stateTitle;
        this.progress = progress;
    }
}